(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cremaWish) return;
    window.__cremaWish = 1;
    var K = 'crema_wishlist';
    var get = function () { try { return JSON.parse(localStorage.getItem(K) || '[]'); } catch (e) { return []; } };
    var set = function (a) { try { localStorage.setItem(K, JSON.stringify(a)); } catch (e) {} };
    var paint = function () {
      var w = get();
      document.querySelectorAll('.crema-card__wish').forEach(function (b) {
        b.classList.toggle('is-on', w.indexOf(b.getAttribute('data-handle')) > -1);
      });
    };
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.crema-card__wish');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var h = b.getAttribute('data-handle'), w = get(), i = w.indexOf(h);
      if (i > -1) { w.splice(i, 1); } else { w.push(h); }
      set(w);
      paint();
    });
    document.addEventListener('DOMContentLoaded', paint);
    window.addEventListener('load', paint);
  })();
  } catch(e) { console.error(e); }
})();

})();
